import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';
// import { map } from 'rxjs/operators';
import { ContactField, ContactFields } from '../models/contact/field';
import { map } from 'rxjs/operators';
import { ContactGropsSearchFilter, ContactGroup, ContactGroups } from '../models/contact/group';
// import { SharedBlacklist } from '../models/reseller/profile';
import { ApiGetContactsOptions, Contact, Contacts } from '../models/contact/contact';
import { flattenObject } from '../utils/utils';
import { ApiGetBlocklistOptionsFilter, Blocked, Blocklist } from '../models/contact/blocklist';

@Injectable({
  providedIn: 'root'
})
export class ContactService {
  private readonly baseUrl;
  selectedList = new Set();

  constructor(private http: HttpClient) {
    this.baseUrl = environment.serverBaseUrl;
  }

  getFields(): Observable<ContactFields> {
    // const data = [
    //   {
    //     idField: 'NAME',
    //     placeholder: '%NAME%',
    //     label: 'contact_name',
    //     dataType: 'STRING',
    //     personalizable: false
    //   },
    //   {
    //     idField: 'CUSTOM1',
    //     placeholder: '%VAT%',
    //     label: 'VAT',
    //     dataType: 'STRING',
    //     personalizable: true
    //   }
    // ];
    // return of(
    //   ContactFields.deserialize({
    //     data: (data ? ((data as unknown) as Array<string>) : []).map(data2 => ContactField.deserialize(data2))
    //   })
    // );

    return this.http.get<Response>(this.baseUrl + 'contacts/fields').pipe(
      map(data => {
        return ContactFields.deserialize({
          data: (data ? ((data as unknown) as Array<string>) : []).map(data2 => ContactField.deserialize(data2))
        });
      })
    );
  }

  addField(contactField: ContactField) {
    return this.http.post(this.baseUrl + 'contacts/fields/personalizable', contactField.label, { responseType: 'text' as 'json' });
  }

  removeField(contactField: ContactField) {
    return this.http.delete(this.baseUrl + 'contacts/fields/personalizable/' + contactField.idField, { responseType: 'text' as 'json' });
  }

  removeMultipleFields(ids: string[]) {
    const options = { responseType: 'text' as 'json', body: { 'delete-fields': false, 'field-ids': ids } };
    return this.http.delete(this.baseUrl + 'contacts/fields/personalizable/', options);
  }

  editField(contactField: ContactField) {
    return this.http.put(this.baseUrl + 'contacts/fields/personalizable/' + contactField.idField, contactField.label, {
      responseType: 'text' as 'json'
    });
  }

  // deprecated: you have to use searchGroups
  getGroups(pageNum?, pageSize?, sortColumn?, sortDirection?): Observable<ContactGroups> {
    let params = new HttpParams();
    if (pageNum) {
      params = params.append('page', pageNum);
    }
    if (pageSize) {
      params = params.append('size', pageSize);
    }
    if (sortColumn) {
      params = params.append('sortColumn', sortColumn);
    }
    if (sortDirection) {
      params = params.append('sortDirection', sortDirection);
    }
    return this.http
      .get<Response>(this.baseUrl + 'contacts/groups', { params })
      .pipe(
        map(data => {
          return ContactGroups.deserialize({
            data: (data && (data as any).data ? ((data as any).data as Array<string>) : []).map(data2 => ContactGroup.deserialize(data2)),
            total: (data as any).total
          });
        })
      );
  }

  searchGroups(filter: ContactGropsSearchFilter, pageNum?, pageSize?, sortColumn?, sortDirection?): Observable<ContactGroups> {
    let params = new HttpParams();
    if (pageNum) {
      params = params.append('page', pageNum);
    }
    if (pageSize) {
      params = params.append('size', pageSize);
    }
    if (sortColumn) {
      params = params.append('sortColumn', sortColumn);
    }
    if (sortDirection) {
      params = params.append('sortDirection', sortDirection);
    }
    return this.http
      .post<Response>(this.baseUrl + 'contacts/groups/search', filter, { params })
      .pipe(
        map(data => {
          return ContactGroups.deserialize({
            data: (data && (data as any).data ? ((data as any).data as Array<string>) : []).map(data2 => ContactGroup.deserialize(data2)),
            total: (data as any).total
          });
        })
      );
  }

  addGroup(contactGroup: ContactGroup) {
    return this.http.post(this.baseUrl + 'contacts/groups', contactGroup).pipe(map(data => ContactGroup.deserialize(data)));
  }

  removeGroup(contactGroup: ContactGroup) {
    const options = { responseType: 'text' as 'json', body: { 'delete-contacts': false } };
    return this.http.delete(this.baseUrl + 'contacts/groups/' + contactGroup.id, options);
  }

  editGroup(contactGroup: ContactGroup) {
    return this.http.put(this.baseUrl + 'contacts/groups/' + contactGroup.id, contactGroup, {
      responseType: 'text' as 'json'
    });
  }

  removeMultipleGroups(ids: string[]) {
    const options = { responseType: 'text' as 'json', body: { 'delete-contacts': false, 'group-ids': ids } };
    return this.http.delete(this.baseUrl + 'contacts/groups', options);
  }

  addEditcontact(contact: Contact): Observable<Contact> {
    /*
    {
    "idContact": "string",
    "phoneNumber": "string",
    "email": "string",
    "fax": "string",
    "name": "string",
    "surname": "string",
    "nickname": "string",
    "gender": "m",
    "country": "string",
    "address": "string",
    "city": "string",
    "province": "string",
    "zip": "string",
    "url": "http://example.com",
    "birthdate": "2020-10-16",
    "rememberdate": "2020-10-16",
    "promotiondate": "2020-10-16",
    "custom1": "string",
    "custom2": "string",
    "custom3": "string",
    "custom4": "string",
    "custom5": "string",
    "custom6": "string",
    "custom7": "string",
    "custom8": "string",
    "custom9": "string",
    "custom10": "string"
    }
     */
    return this.http.put(this.baseUrl + 'contacts', flattenObject(contact)).pipe(map(data => Contact.deserialize(data)));
  }

  addContactsGroup(contactGroups: ContactGroup | ContactGroup[], contacts, body?: ApiGetContactsOptions) {
    const request = {
      // 'id-group': contactGroup.id,
      groups: Array.isArray(contactGroups) ? contactGroups.map(x => x.id) : [contactGroups.id],
      contacts: {
        search: body ? body : {}
      }
    };
    if (contacts.length) {
      request.contacts['contact-ids'] = contacts.map(contact => contact.idContact);
    }
    return this.http.post(this.baseUrl + 'contacts/groups/add-contacts', request, {
      responseType: 'text' as 'json'
    });
  }

  removeContactsGroup(contactGroups: ContactGroup | ContactGroup[], contacts, body?: ApiGetContactsOptions) {
    const request = {
      // 'id-group': contactGroup.id,
      groups: Array.isArray(contactGroups) ? contactGroups.map(x => x.id) : [contactGroups.id],
      contacts: {
        search: body ? body : {}
      }
    };
    if (contacts.length) {
      request.contacts['contact-ids'] = contacts.map(contact => contact.idContact);
    }
    const options = { responseType: 'text' as 'json', body: request };
    return this.http.delete(this.baseUrl + 'contacts/groups/delete-contacts', options);
  }

  getContact(idContact): Observable<Contact> {
    return this.http.get<Response>(this.baseUrl + 'contacts/' + idContact).pipe(map(data => Contact.deserialize(data)));
  }

  getContacts(pageNum?, pageSize?, sortColumn?, sortDirection?, body?: ApiGetContactsOptions): Observable<Contact> {
    let params = new HttpParams();
    if (pageNum) {
      params = params.append('page', pageNum);
    }
    if (pageSize) {
      params = params.append('size', pageSize);
    }
    if (sortColumn) {
      params = params.append('sortColumn', sortColumn);
    } else {
      params = params.append('sortColumn', 'NAME');
    }
    if (sortDirection) {
      params = params.append('sortDirection', sortDirection);
    } else {
      params = params.append('sortDirection', 'd');
    }
    // if (returnFormat) {
    params = params.append('returnFormat', 'FULL');
    // }
    if (body && body.filters && body.filters.length) {
      delete body['basic-filters'];
    }

    return this.http
      .post(this.baseUrl + 'contacts/search', body, {
        params
      })
      .pipe(
        map(data => {
          return Contacts.deserialize({
            data: (data && (data as any).data ? ((data as any).data as Array<string>) : []).map(data2 => Contact.deserialize(data2)),
            total: (data as any).total
          });
        })
      );
  }

  deleteContacts(contacts?: Contact[], body?: ApiGetContactsOptions) {
    const request = {
      search: body
    };
    if (contacts.length) {
      request['contact-ids'] = contacts.map(contact => contact.idContact);
    }
    const options = { responseType: 'text' as 'json', body: request };
    return this.http.delete(this.baseUrl + 'contacts', options);
  }

  exportContacts(email, format, contacts?: Contact[], options?: ApiGetContactsOptions) {
    const search = { search: options ? options : {} };
    if (contacts.length) {
      search['contact-ids'] = contacts.map(contact => contact.idContact);
    }
    const body = {
      email,
      format,
      search
    };
    return this.http.post(this.baseUrl + 'contacts/export', body);
  }

  getBlocklist(pageNum?, pageSize?, sortColumn?, sortDirection?, filters?): Observable<Blocklist> {
    let params = new HttpParams();
    // dateFrom?: string, dateTo?: string, number?: string, origins?: string[]
    if (pageNum) {
      params = params.append('page', pageNum);
    }
    if (pageSize) {
      params = params.append('size', pageSize);
    }
    if (sortColumn) {
      params = params.append('sortColumn', sortColumn);
    } else {
      // params = params.append('sortColumn', 'NUMBER');
    }
    if (sortDirection) {
      params = params.append('sortDirection', sortDirection);
    } else {
      // params = params.append('sortDirection', 'd');
    }
    let body = {};
    if (filters) {
      body = filters;
    }
    return this.http
      .post(this.baseUrl + 'blacklist/search/blacklistNumbers', body, {
        params
      })
      .pipe(
        map(data => {
          return Blocklist.deserialize({
            data: (data && (data as any).data ? ((data as any).data as Array<string>) : []).map(data2 => Blocked.deserialize(data2)),
            total: (data as any).total
          });
        })
      );
  }

  importBlocklist(formData: FormData) {
    return this.http.post(this.baseUrl + 'blacklist/file', formData);
  }

  addBlocklist(numbers: string[]) {
    const request = {
      numbers
    };
    return this.http.post(this.baseUrl + 'blacklist', request, {
      responseType: 'text' as 'json'
    });
  }

  removeBlocklist(numbers: string[], filters?) {
    // dateFrom?: string, dateTo?: string, origins?: string[]
    const request: any = {};
    if (numbers) {
      request.numbers = numbers;
    }
    // if (dateFrom) {
    //   request.dateFrom = dateFrom;
    // }
    // if (dateTo) {
    //   request.dateTo = dateTo;
    // }
    // if (origins) {
    //   request.origins = origins;
    // }
    const options = { responseType: 'text' as 'json', body: request };
    return this.http.delete(this.baseUrl + 'blacklist', options);
  }

  getBlocklistOrigins(): Observable<any> {
    return this.http.get<Response>(this.baseUrl + 'blacklist/origins');
    //   .pipe(
    //   map(data => {
    //     return ContactFields.deserialize({
    //       data: (data ? ((data as unknown) as Array<string>) : []).map(data2 => ContactField.deserialize(data2))
    //     });
    //   })
    // );
  }

  exportBlockLists(email, format, contacts?: Blocked[], options?: ApiGetBlocklistOptionsFilter) {
    const search: any = options;
    if (contacts.length) {
      search.numbers = contacts.map(contact => contact.number);
    }
    const body = {
      email,
      format,
      search
    };
    return this.http.post(this.baseUrl + 'blacklist/export', body);
  }

  exportBlockListsGlobal(email, format, dateFrom?, dateTo?, origins?) {
    const search: any = {};
    if (origins?.length) {
      search.origins = origins.map(origin => origin.label);
    }
    if (dateFrom) {
      search.dateFrom = dateFrom;
    }
    if (dateTo) {
      search.dateTo = dateTo;
    }
    const body = {
      email,
      format,
      search
    };
    return this.http.post(this.baseUrl + 'blacklist/export', body);
  }

  getShareableUserBlackList(): Observable<any> {
    return this.http.get<Response>(this.baseUrl + 'blacklist/list');
  }

  updateContactsSubscription(body): Observable<any> {
    return this.http.post(this.baseUrl + 'contacts/update-contacts-subscriptions', body);
  }
}
